export default __webpack_public_path__ + "static/media/henry-david-thoreau.c06ca182.png";